module.exports = __webpack_public_path__ + "img/icon-comment.9226bda0.svg";